module.exports = __webpack_public_path__ + "img/intelligent_adjustment.42f5e625.png";